/*

ashraf 10/06/2022  2698947782 fixed page break issue in role data
suresh 10/17/2022 2700799562 Design Enhancements in global Field Group, List.
Suresh Peddavoora 10/20/2022 2700753823 - Modified styles for subtitle text in global fields.
Suresh Peddavoora 10/29/2022 2700753823, 3075154998 Added profile icons styles globally in header.
ashraf 11/30/2022  2698947782 fixed udw window prepopulation
ashraf 12/01/2022  2698947782 changed label for custom windows
Rohini 02/09/2023 2698964415 added the css properties for textfields
Prakash 22/05/2023 2698964415 fixed overlap issue in header issue in WorkQueue .
Sohel 05/24/2023 2698964415 Fixed UserName issue
Ravi 05/30/2023 2698964415  show window Description instead of window name
*/

import React, {useEffect, useState, useContext} from 'react';
import clsx from 'clsx';
import CmtDropdownMenu from '../Dashboard/CmtDropdownMenu';
import { Box, makeStyles } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import {useSelector, useDispatch} from 'react-redux';
import SelectTabContextProvider from '../../components/SelectTabContext/SelectTabContext';
import {fetchRole} from '../../redux/reducers/role';
import {SuccessSnackbar} from '../../components/CustomSnackBar';
import { Button } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  profileRoot: {
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'position': 'relative',
  },
}));

const Profile = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [userDetails, setUserDetails] = useState('');
  const {roleData} = useSelector(({role}) => role);
  const [windows1, setWindows1] = useState();
  const {udwData} = useSelector(({udwWindows}) => udwWindows);
  const {setNewTabData, windowsData, clientMaintainanceData, setClientNewTabData} =
    useContext(SelectTabContextProvider);
  const {successMsg} = useSelector(({clientGeneral}) => clientGeneral);
  const authToken = sessionStorage.getItem('token');
  useEffect(() => {
    if (authToken) {
      dispatch(fetchRole());
    }
  }, [authToken]);

  let windows;
  useEffect(() => {
    if (roleData) {
      const authorisedWindows = roleData?.window?.['Custom Window'] ?
        roleData?.window?.['Custom Window'] :
        {};
      windows = Object.keys(authorisedWindows);
      setWindows1(windows?.map((item) => item));
    }
  }, [roleData]);

  useEffect(() => {
    setUserDetails(roleData?.userDetails);
    if (roleData && Object.keys(roleData) && roleData.window) {
      let newTab = [];
      if (roleData?.window?.['Core Windows']) {
        newTab = windowsData.filter((item) => {
          if (Object.keys(roleData?.window?.['Core Windows']).includes(item?.code)) {
            return item;
          }
        });
      }

      let windows = [];
      const customWindows = [];
      if (udwData && udwData.length > 0) {
        udwData.map((item) => {
          if (windows1?.includes(String(item?.windowName))) {
            customWindows.push({
              label: `${item?.windowDescription}` || '',
              code: item.windowName,
              windowType: 'Custom Windows',
            });
          }
        });
        windows = [...newTab, ...customWindows];
      } else {
        windows = [...newTab];
      }
      setNewTabData(windows);
    }
  }, [roleData, udwData, windows1]);

  useEffect(() => {
    setUserDetails(roleData?.userDetails);
    if (
      roleData &&
      Object.keys(roleData) &&
      roleData.window &&
      roleData?.window?.['Client Maintenance']
    ) {
      const newTab = clientMaintainanceData.filter((item) =>
        Object.keys(roleData?.window?.['Client Maintenance']).includes(item.code),
      );

      setClientNewTabData(newTab);
    }
  }, [roleData]);
  return (
    <Box className={clsx(classes.profileRoot, 'Cmt-profile-pic')}>
      <CmtDropdownMenu
        TriggerComponent={
          <Button color="inherit" endIcon={<ArrowDropDownIcon fontSize="small" />}>
            <span style={{ textTransform: 'none', fontWeight: 'bold' }}>{userDetails?.userLoginName}</span>
          </Button>
        }
      />
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </Box>
  );
};

export default Profile;
